import React, { useState, useEffect, useCallback } from 'react';
import { znsAPI, userAPI } from '../services/api';
import { toast } from 'react-toastify';
import '../styles/UserManagement.css';

const STATUS_LABELS = {
  sent: 'Thành công',
  failed: 'Thất bại',
  pending: 'Đang xử lý'
};

function History() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({ status: '', user_id: '' });
  const [users, setUsers] = useState([]);

  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = currentUser.role === 'admin';

  useEffect(() => {
    // Chỉ admin mới cần danh sách user để lọc
    if (isAdmin) {
      userAPI.getAll().then((r) => r.data.success && setUsers(r.data.data)).catch(() => {});
    }
  }, [isAdmin]);

  const loadHistory = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page, limit: 20 };
      if (filters.status) params.status = filters.status;
      if (filters.user_id) params.user_id = filters.user_id;
      const res = await znsAPI.getHistory(params);
      if (res.data.success) {
        setMessages(res.data.data.messages);
        setTotalPages(res.data.data.pagination.total_pages || 1);
      }
    } catch (e) {
      toast.error('Không tải được lịch sử gửi tin');
    } finally {
      setLoading(false);
    }
  }, [page, filters]);

  useEffect(() => { loadHistory(); }, [loadHistory]);

  return (
    <div className="um-container">
      <div className="page-header">
        <h1>Lịch sử gửi tin</h1>
        <p>Danh sách ZNS đã gửi{isAdmin ? ' (toàn hệ thống)' : ''}</p>
      </div>

      <div className="card">
        <div className="um-filters">
          {isAdmin && (
            <select
              value={filters.user_id}
              onChange={(e) => { setPage(1); setFilters({ ...filters, user_id: e.target.value }); }}
            >
              <option value="">— Tất cả người gửi —</option>
              {users.map((u) => (
                <option key={u.id} value={u.id}>{u.full_name || u.username}</option>
              ))}
            </select>
          )}

          <select
            value={filters.status}
            onChange={(e) => { setPage(1); setFilters({ ...filters, status: e.target.value }); }}
          >
            <option value="">— Tất cả trạng thái —</option>
            <option value="sent">Thành công</option>
            <option value="failed">Thất bại</option>
            <option value="pending">Đang xử lý</option>
          </select>

          <button className="btn-secondary" onClick={loadHistory}>Làm mới</button>
        </div>

        {loading ? (
          <div className="loading">Đang tải...</div>
        ) : (
          <table className="um-table">
            <thead>
              <tr>
                <th>Thời gian</th>
                {isAdmin && <th>Người gửi</th>}
                <th>Số điện thoại</th>
                <th>Template</th>
                <th>Trạng thái</th>
                <th>Ghi chú</th>
              </tr>
            </thead>
            <tbody>
              {messages.length === 0 ? (
                <tr><td colSpan={isAdmin ? 6 : 5} className="empty-state">Chưa có dữ liệu</td></tr>
              ) : messages.map((m) => (
                <tr key={m.id}>
                  <td className="um-sub">{new Date(m.created_at).toLocaleString('vi-VN')}</td>
                  {isAdmin && <td>{m.username || '—'}</td>}
                  <td>{m.phone_number}</td>
                  <td>{m.template_name || '—'}</td>
                  <td>
                    <span className={`um-chip ${m.status === 'failed' ? 'chip-fail' : ''}`}>
                      {STATUS_LABELS[m.status] || m.status}
                    </span>
                  </td>
                  <td className="um-sub">{m.error_message || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {totalPages > 1 && (
          <div className="um-pagination">
            <button className="btn-secondary" disabled={page <= 1} onClick={() => setPage(page - 1)}>← Trước</button>
            <span>Trang {page}/{totalPages}</span>
            <button className="btn-secondary" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Sau →</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default History;
